// extracted by mini-css-extract-plugin
export var gray = "Link-module__gray___uRcUQ";
export var primary = "Link-module__primary___fT0c3";